import store from '../../../../store/createStore';
import queryString from 'query-string';
import moment from 'moment';
import { reservationActionTypes } from './actionTypes';
import { bookingApi, http } from 'services/http';
import { alertError } from 'services/alerts';
import { prepareNationalNumber, sortArrayFromTag, getGenderFromNN } from 'services/functions';
import { ROLES, phonePrefix } from 'services/constants';
import { parsePatientTypeUG } from '../services/slots';
import { sendMessageToApp } from 'src/services/http';
//──── Mock data ─────────────────────────────────────────────────────────────────────────
import {
  questionList,
  behaviorList,
  testQuestions
} from '../../../patient/Reservation/__mocks__/question_section';
import {
  campuses,
  practitioners,
  freeSlots
} from '../../../patient/Reservation/__mocks__/filterData';

const transformRequestOptions = params => {
  let options = '';

  const strToArr = (el, key) => {
    const arr = typeof el === 'string' && el.split(',');
    if (arr.length === 1) {
      options += `${key}=${el}&`;
    } else if (arr.length > 1) {
      for (let i = 0; i < arr.length; i += 1) {
        options += `${key}=${arr[i]}&`;
      }
    } else {
      options += `${key}=${el}&`;
    }
  };

  Object.keys(params).forEach(key => {
    if (typeof params[key] === 'object' && params[key] && params[key].length) {
      params[key].forEach(el => {
        strToArr(el, key);
      });
    } else if (typeof params[key] !== 'object' && params[key]) {
      strToArr(params[key], key);
    }
  });
  return options ? options.slice(0, -1) : options;
};

//──── Slots ─────────────────────────────────────────────────────────────────────────────
const sortSlotsForDate = slotArr => {
  if (Array.isArray(slotArr)) {
    return slotArr.sort((a, b) => {
      if (a.startTime && b.startTime) {
        return moment(a.startTime).isAfter(moment(b.startTime)) ? 1 : -1;
      }
      return 1;
    });
  }
  return slotArr;
};

export const addMoreFreeSlots = options => dispatch => {
  console.log('addMoreFreeSlots options ', options);
  bookingApi
    .get('freeslots', {
      params: options,
      withoutLoader: true,
      paramsSerializer: params => transformRequestOptions(params)
    })
    .then(({ data }) => {
      if (data && Array.isArray(data)) {
        dispatch(addMoreSlots(sortSlotsForDate(data)));
      } else {
        throw Error('Not correct response');
      }
    })
    .catch(({ response }) => {
      if (response && response.status !== 400 && response.status !== 401 && !response) {
        alertError();
      }
      dispatch(errorLoadSlots([]));
    });
};

export const getFreeSlots = options => dispatch => {
  console.log('getFreeSlots options ', options);
  bookingApi
    .get('freeslots', {
      params: options,
      withoutLoader: true,
      paramsSerializer: params => transformRequestOptions(params)
    })
    .then(({ data }) => {
      if (data && Array.isArray(data)) {
        dispatch(successLoadSlots(sortSlotsForDate(data)));
      } else {
        throw Error('Not correct response');
      }
    })
    .catch(({ response }) => {
      if ((response && response.status !== 400 && response.status !== 401) || !response) {
        alertError();
      }
      dispatch(errorLoadSlots([]));
    });
};

const addMoreSlots = list => ({
  type: reservationActionTypes.ADD_MORE_SLOTS,
  payload: list
});

const successLoadSlots = slotList => ({
  type: reservationActionTypes.SUCCESS_LOAD_SLOTS,
  payload: slotList
});

const errorLoadSlots = slotList => ({
  type: reservationActionTypes.ERROR_LOAD_SLOTS,
  payload: slotList
});

export const resetSlots = () => ({
  type: reservationActionTypes.RESET_SLOTS
});

export const changeStep = step => ({
  type: reservationActionTypes.CHANGE_STEP,
  payload: step
});

export const selectSlot = slot => ({
  type: reservationActionTypes.SELECT_SLOT,
  payload: slot
});

export const clearReservationStep = () => ({
  type: reservationActionTypes.CLEAR_RESERVATION_STEP
});

//──── Booked slots ──────────────────────────────────────────────────────────────────────
const preparePayloadData = (patientInfo, reservation) => {
  const returnObj = {};
  const patientInfoObj = {};
  // if reservation form was filled
  const forms = store.getState().form;
  const reservationForm = forms && forms.reservation && forms.reservation.values;
  const setPatientCommon = target => {
    patientInfoObj['firstName'] = target.firstName;
    patientInfoObj['lastName'] = target.lastName;
    patientInfoObj['email'] = target.email;
    patientInfoObj['gender'] = patientInfo.gender;
    patientInfoObj['phone'] = patientInfo.phone;
  };
  if (reservationForm && reservationForm.nationalNumber) {
    setPatientCommon(reservationForm);
    patientInfoObj['gender'] = getGenderFromNN(reservationForm.nationalNumber);
    patientInfoObj['phone'] = phonePrefix + reservationForm.phone;
  } else if (patientInfo) {
    // if auth user
    setPatientCommon(patientInfo);
  }

  const results =
    reservation && reservation.questionSection && reservation.questionSection.questionResult;

  if (results && typeof results === 'object') {
    for (let key in results) {
      returnObj[key] = Array.isArray(results[key]) ? results[key].join() : results[key];
    }
  }
  return Object.assign(returnObj, patientInfoObj);
};

export const createBooking = captchaResponse => dispatch => {
  const patientInfo = store.getState().patient.patientInfo;
  const reservation = store.getState().patient.reservation;
  const activeSlot = reservation && reservation.activeSlot;
  const external = patientInfo && patientInfo.external;
  const payloadData = preparePayloadData(patientInfo, reservation);

  const body = {
    appointmentTypeId: activeSlot.appointmentTypeId,
    internalId: activeSlot && activeSlot.id,
    startDateTime: activeSlot && activeSlot.startTime,
    endDateTime: activeSlot && activeSlot.endTime,
    payload: { ...payloadData }
  };
  if (captchaResponse) {
    body.captchaResponse = captchaResponse;
  }

  if (payloadData.email) {
    body.email = payloadData.email;
  }

  Object.assign(body, parsePatientTypeUG(external));

  dispatch(clearPreferData()); // clear prefer data if we have it

  return bookingApi
    .post('bookings', body)
    .then(({ data }) => {
      dispatch(createBookingSuccess(data));
      return true;
    })
    .catch(err => {
      const { response } = err;
      if (response && response.status !== 400 && response.status !== 401) {
        dispatch(createBookingError());

        if (
          response.status === 406 &&
          response.data &&
          response.data.Codes &&
          Array.isArray(response.data.Codes)
        ) {
          const codeErrorsList = response.data.Codes;
          codeErrorsList.forEach(code => {
            switch (String(code)) {
              case '200': {
                alertError('slot_not_found');
                throw Error('slot_not_found');
              }
              case '203': {
                alertError('booked_max_appointments');
                throw Error('booked_max_appointments');
              }
              default: {
                alertError();
                break;
              }
            }
          });
        } else {
          alertError();
          throw Error('slot_not_found');
        }
      } else {
        sendMessageToApp({ err: err });
        throw Error(err);
      }
    });
};

const createBookingSuccess = data => ({
  type: reservationActionTypes.CREATE_BOOKING_SUCCESS,
  payload: data
});

const createBookingError = () => ({
  type: reservationActionTypes.CREATE_BOOKING_ERROR,
  payload: {}
});

//──── Booking filter ────────────────────────────────────────────────────────────────────

// Practitioners

export const getPractitioners = () => {
  // test data
  // practitioners.unshift(selectAllPractitioner);
  // store.dispatch(addPractitioners(practitioners));

  http
    .get('practitioners')
    .then(({ data }) => {
      if (data && data instanceof Array) {
        const arr = data.filter(pr => pr.onlineBookingActive);
        store.dispatch(setPractitioners(sortArrayFromTag(arr, 'lastName')));
      } else {
        alertError();
      }
    })
    .catch(({ response }) => {
      if (response && response.status !== 400 && response.status !== 401) {
        alertError();
      }
      errorLoadSlots([]);
    });
};

const setPractitioners = practitioners => ({
  type: reservationActionTypes.SET_PRACTITIONERS,
  payload: practitioners
});

export const setGroupPractitioners = list => ({
  type: reservationActionTypes.SET_GROUP_PRACTITIONERS,
  payload: list
});

export const clearGroupPractitioners = () => ({
  type: reservationActionTypes.CLEAR_GROUP_PRACTITIONERS
});

export const getPrWithDigitalFlow = cb => {
  http
    .get('practitioners')
    .then(({ data }) => {
      if (data && Array.isArray(data)) {
        const onlyActive = data.filter(pr => pr && pr.isActive);
        store.dispatch({
          type: reservationActionTypes.SET_PR_WITH_DIGITAL_FLOW,
          payload: onlyActive
        });
      }
      cb && cb();
    })
    .catch(() => {
      cb && cb();
    });
};
// Campuses

export const getCampuses = () => {
  // test data
  // store.dispatch(addCampuses(campuses));

  bookingApi
    .get('campuses')
    .then(({ data }) => {
      store.dispatch(addCampuses(data));
    })
    .catch(({ response }) => {
      if (response && response.status !== 400 && response.status !== 401) {
        alertError();
      }
      errorLoadSlots([]);
    });
};

const addCampuses = campuses => {
  return {
    type: reservationActionTypes.ADD_CAMPUSES,
    payload: campuses
  };
};

export const setSlotsFilters = initialData => ({
  type: reservationActionTypes.SET_SLOTS_FILTERS,
  payload: initialData
});

export const updateSlotsFilters = updateData => ({
  type: reservationActionTypes.UPDATE_SLOTS_FILTERS,
  payload: updateData
});

export const clearSlotsFilters = () => ({
  type: reservationActionTypes.CLEAR_SLOTS_FILTERS
});

export const updateSlotsTimeStamp = () => ({
  type: reservationActionTypes.UPDATE_SLOTS_FILTERS,
  payload: { timeStamp: new Date().toUTCString() }
});

//──── Work with question section ────────────────────────────────────────────────────────
export const loadQuestions = () => dispatch => {
  bookingApi
    .get('q')
    .then(({ data }) => {
      if (data && data.questions) {
        dispatch(setQuestionsList(data.questions));
        // dispatch(setQuestionsList(testQuestions.questions));
      } else {
        alertError();
      }
    })
    .catch(() => {
      alertError();
      dispatch(loadQuestionsError());
    });
};

const setQuestionsList = list => ({
  type: reservationActionTypes.LOAD_QUESTION_LIST,
  payload: list
});

const loadQuestionsError = () => ({
  type: reservationActionTypes.LOAD_QUESTIONS_ERROR
});

export const setQuestionResult = data => ({
  type: reservationActionTypes.SET_QUESTIONS_RESULT,
  payload: data
});

export const clearQuestionResult = () => ({
  type: reservationActionTypes.CLEAR_QUESTIONS_RESULT
});

//──── User identifer ────────────────────────────────────────────────────────────────────
export const nationalNumberIsUnique = nationalNumber =>
  http
    .get(`patients/${prepareNationalNumber(nationalNumber)}/unique`)
    .then(res => {
      const { data } = res;
      if (data) {
        return data && data.isUnique;
      } else {
        alertError();
      }
    })
    .catch(() => {
      alertError();
    });

export const findPatientInSystem = userData => {
  // get data from UG
  return http
    .get('patients', {
      params: { ...userData }
    })
    .then(({ data }) => {
      return refreshUGUserToken(userData.nationalNumber, { external: data });
    })
    .catch(err => {
      if (err && err.response && err.response.status === 404) {
        // don't find this user in UG system - we need create new user
        userData.nationalNumber = prepareNationalNumber(userData.nationalNumber);
        return http
          .post('patients', { ...userData })
          .then(({ data }) => {
            if (data && data.id) {
              store.dispatch(cleanCaptchaToken());
              const _updateUserData = Object.assign({}, userData);
              _updateUserData.ultraGendaId = data.id;
              return refreshUGUserToken(userData.nationalNumber, {
                external: _updateUserData
              });
            } else {
              alertError();
            }
          })
          .catch(err => {
            if (err.response && err.response.data && err.response.data.CaptchaResponse) {
              store.dispatch(cleanCaptchaToken());
              alertError('Capctha was expired. Please try again.');
              throw Error(err);
            } else {
              alertError();
            }
          });
      } else {
        alertError();
      }
    });
};

const refreshUGUserToken = (nationalNumber, returnValues) => {
  const auth = store.getState().auth;
  const isPatientAuth = auth.isAuthenticated && auth.role === ROLES.PATIENT;

  if (isPatientAuth) {
    return returnValues;
  } else {
    return http
      .post(`patients/migration?nationalNumber=${nationalNumber}`)
      .then(() => returnValues)
      .catch(() => returnValues);
  }
};

//──── Prefer data ───────────────────────────────────────────────────────────────────────
export const readAndSetPreferData = obj => dispatch => {
  if (obj) {
    dispatch(setPreferData(obj));
  } else if (window.location && window.location.search) {
    const queryObj = queryString.parse(window.location.search);
    if (queryObj) {
      dispatch(setPreferData(queryObj));
    }
  }
};

const setPreferData = dataObj => {
  return {
    type: reservationActionTypes.SET_PREFER_DATA,
    payload: dataObj
  };
};

export const clearPreferData = () => ({
  type: reservationActionTypes.CLEAR_PREFER_DATA
});

//──── Captcha ───────────────────────────────────────────────────────────────────────────
export const setCaptchaToken = token => ({
  type: reservationActionTypes.SET_CAPTCHA_TOKEN,
  payload: token
});

export const cleanCaptchaToken = () => ({
  type: reservationActionTypes.CLEAN_CAPTCHA_TOKEN
});
